<template>
    <Vue3EasyDataTable
        v-model:items-selected="selectedOperations"
        :headers="headers"
        :items="operations"
        header-item-class-name="table-header"
        table-class-name="customize-table"
        :table-height="600"
        :rows-items="[100, 1000, 10000]"
        :rows-per-page="1000"
        theme-color="#242939"
        ref="datatable"
        :loading="loading"
    >
        <template #loading>
            <v-progress-circular
                color="blue-lighten-3"
                indeterminate
                :size="120"
            >
                <v-img
                    src="/images/d3_connect.png"
                    v-if="loading"
                    :size="10"
                    class="loading-spinner"
                    :style="{
                        marginLeft: '9px',
                    }"
                    indeterminate
                ></v-img>
            </v-progress-circular>
        </template>
    </Vue3EasyDataTable>
</template>

<script>
    import Vue3EasyDataTable from "vue3-easy-data-table";
    import { useJobEntryStore } from '../../../../../stores/ProjectManagement/JobEntry';
    import { mapWritableState } from 'pinia';
    import axios from "axios";

    export default {
        name: "OperationsWindow",
        components: {
            Vue3EasyDataTable
        },
        computed: {
            ...mapWritableState(useJobEntryStore, {
                selectedOperations: "selectedOperations",
            }),
        },
        watch: {},
        mounted() {
            this.fetchOperationsTableData();
        },
        data() {
            return {
                headers: [
                    { text: "Operation", value: "OpCode", sortable: true },
                    { text: "Description", value: "OpDesc", sortable: true },
                ],
                operations: [],
                loading: false
            }
        },
        methods: {
            async fetchOperationsTableData() {
                await axios
                    .get( route("legacy-api.engJobOperations", {subcontract: false}) )
                    .then((response) => {
                        this.operations = response.data;
                        this.loading = false;
                    })
                    .catch((err) => {
                        console.log(err)
                    });
            },
        }
    }
</script>

<style scoped>

</style>
